module.exports = __webpack_public_path__ + "img/MyChoice2201_AAB.24b4634d.jpg";